import {
	Home,
	Box,
	Chrome,
	Truck,
	Clipboard,
	Layers,
	Phone,
	Tool,
	Users,
	BarChart,
	Settings,
	MessageSquare,
	Tag,
	ShoppingCart,
} from "react-feather";

export const MENUITEMS = [
	{
		sidebartitle: "القائمة الرئيسية",
		path: "/dashboard",
		title: "لوحة التحكم",
		icon: Home,
		type: "link",
		badgeType: "primary",
		active: false,
	},
	{
		sidebartitle: "إدارة المتجر",
		path: "/products",
		title: "الأصناف والمنتجات",
		icon: Box,
		type: "sub",
		active: false,
		children: [
			{ path: "/category", title: "الأقسام الأساسية", type: "link" },
			{ path: "/products", title: "قائمة المنتجات", type: "link" },
		],
	},
	{
		path: "/sales",
		title: "المبيعات والطلبيات",
		icon: ShoppingCart,
		type: "sub",
		active: false,
		children: [
			{ path: "/sales/orders", title: "قائمة الطلبيات", type: "link" },
			// { path: "/Invoice", title: "الفواتير", type: "link" },
		],
	},
	{
		path: "/Delivery",
		title: "خدمات التوصيل",
		icon: Truck,
		type: "sub",
		active: false,
		children: [{ path: "/AddCity", title: "إدارة المدن", type: "link" }],
	},
	{
		sidebartitle: "المحتوى والواجهة",
		path: "/main-page",
		title: "الصفحة الرئيسية",
		icon: Chrome,
		type: "sub",
		active: false,
		children: [
			{ path: "/slider", title: "الصور الرئيسية (Slider)", type: "link" },
			{ path: "/ParallaxImage", title: "الصور المتحركة (Parallax)", type: "link" },
			{ path: "/bestseller", title: "الأكثر مبيعاً", type: "link" },
			{
				path: "/category-main-page",
				title: "أقسام الصفحة الرئيسية",
				type: "link",
			},
		],
	},
	{
		sidebartitle: "خدمة العملاء",
		title: "تواصل معنا",
		icon: Phone,
		type: "sub",
		active: false,
		children: [
			{ path: "/contact-us", title: "معلومات التواصل", type: "link" },
			{
				path: "/Messages",
				title: "رسائل العملاء",
				icon: MessageSquare,
				type: "link",
			},
		],
	},
	{
		sidebartitle: "التقارير والإخصائيات",
		path: "/Reports",
		title: "التقارير",
		icon: BarChart,
		type: "sub",
		active: false,
		children: [
			{ path: "/reports/stock-report", title: "تنبيهات المخزون", type: "link" },
			{
				path: "/reports/order-report",
				title: "إجمالي المبيعات",
				type: "link",
			},
			{ path: "/reports/product-count", title: "مبيعات الأصناف", type: "link" },
		],
	},
	{
		sidebartitle: "الإعدادات والنظام",
		title: "تحكم الموقع",
		icon: Settings,
		type: "sub",
		active: false,
		children: [
			{ path: "/switch-off", title: "تشغيل/إيقاف الموقع", type: "link" },
			{ path: "/promo-codes", title: "كوبونات الخصم", icon: Tag, type: "link" },
		],
	},
	{
		title: "المستخدمين والصلاحيات",
		icon: Users,
		type: "sub",
		active: false,
		children: [{ path: "/user-list", title: "إدارة المستخدمين", type: "link" }],
	},
];
